import { render, staticRenderFns } from "./MomentDetailPage.vue?vue&type=template&id=6a7ce426&scoped=true&"
import script from "./MomentDetailPage.vue?vue&type=script&lang=js&"
export * from "./MomentDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./MomentDetailPage.vue?vue&type=style&index=0&id=6a7ce426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ce426",
  null
  
)

export default component.exports